<template>
  <div class="modal-loader">
    <VueSpinnerDots size="60" id="spinner" />
  </div>
</template>

<script setup>
import { VueSpinnerDots } from "vue3-spinners";
</script>

<style lang="scss" scoped>
.modal-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  min-height: 300px;
  text-align: center;

  #spinner {
    color: var(--brand);
  }
}
</style>
